import { Axis, AxisType } from './axis';


export class Series
{
    public data     : number[];
    public dash     : number[];
    public color    : string;
    public label    : string;
    public rating   : number;
    public unit     : string;
    public axisType : AxisType;
    public accuracy : number | undefined;

    constructor(label : string, rating : number, unit : string, color : string, styleDash : number[], axisType : AxisType) {
        this.data     = [];
        this.dash     = styleDash;
        this.color    = color;
        this.label    = label;
        this.axisType = axisType;
        this.unit     = unit;
        this.rating   = rating;
    }

    append(value : number) {
        this.data.push(value);
    }

    drawLines(ctx : CanvasRenderingContext2D, xAxis : Axis, yAxis : Axis) {
        ctx.beginPath();
        this.data.forEach((val, i) => {
          const x = xAxis.valueToPixel(i);
          const y = yAxis.valueToPixel(val);
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        });
        ctx.setLineDash(this.dash);
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 2.5;
        ctx.stroke();
    }

    drawDots(ctx : CanvasRenderingContext2D, xAxis : Axis, yAxis : Axis) {

        this.data.forEach((val, i) => {
            const x = xAxis.valueToPixel(i);
            const y = yAxis.valueToPixel(val);

            ctx.fillStyle = this.color;
            ctx.beginPath();
            ctx.arc(x, y, 5, 0, 2 * Math.PI);
            ctx.fill();

            ctx.fillStyle = "white";
            ctx.beginPath();
            ctx.arc(x, y, 2.5, 0, 2 * Math.PI);
            ctx.fill();
        });
    }

    getMaxX() {
        return this.data.length - 1;
    }

    getMaxY() {
        return Math.max(...this.data);
    }
}

